import { Platform } from 'react-native';

export const InputAccessoryViewSafe =
  Platform.OS === 'ios' ? require('react-native').InputAccessoryView : null;
